<template>
  <div>
    <v-container>
       <v-row>
        <v-col cols='12' md='4'>
          <basics
            v-if='estimate'
            :estimate='estimate'
            @update='updateEstimate'
          ></basics>
        </v-col>
        <v-col cols='12' md='4'>
          <snow-details
            v-if='snowEstimate'
            :estimate='estimate'
            :snowEstimate='snowEstimate'
            @update='updateEstimate'
            @updateDetail='updateSnowEstimate'
          ></snow-details>
        </v-col>
        <v-col cols='12' md='4'>
          <driveway-rating
            v-if='estimate'
            :estimate='estimate'
            @updateDetail='updateSnowEstimate'
            @update='updateEstimate'
          ></driveway-rating>
        </v-col>
        <v-col cols='12' md='4'>
          <site-address
            v-if='estimate'
            :estimate='estimate'
            :snowEstimate='snowEstimate'
            @update='updateEstimate'
          ></site-address>
        </v-col>
        <v-col cols='12' md='4'>
          <contacts
            v-if='estimate'
            :estimate='estimate'
            @update='updateEstimate'
          ></contacts>
        </v-col>
        <v-col cols='12' md='4'>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols='12' md='4'>
          <customer-notes
            v-if='estimate'
            :estimate='estimate'
            @update='updateEstimate'
          ></customer-notes>
        </v-col>
        <v-col cols='12' md='4'>
          <field-instructions
            v-if='estimate'
            :estimate='estimate'
            @update='updateEstimate'
          ></field-instructions>
        </v-col>
        <v-col cols='12' md='4'>
          <invoicing-notes
            v-if='estimate'
            :estimate='estimate'
            @update='updateEstimate'
          ></invoicing-notes>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols='12' md='8'>
          <invoices
            v-if='estimate'
            :estimate='estimate'
          ></invoices>
        </v-col>
        <v-col cols='12' md='4' align-self='end'>
          <quote-total
            v-if='estimate'
            :obj='estimate'
          ></quote-total>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Basics from '@/modules/estimates/components/Basics';
import SiteAddress from '@/modules/estimates/components/SiteAddress';
import Details from '@/modules/estimates/components/snow/Details';
import DrivewayRating from '@/modules/estimates/components/snow/DrivewayRating';
import Contacts from '@/modules/estimates/components/Contacts';
import FieldInstructions from '@/modules/estimates/components/FieldInstructions';
import CustomerNotes from '@/modules/estimates/components/CustomerNotes';
import InvoicingNotes from '@/modules/estimates/components/InvoicingNotes';
import QuoteTotal from '@/modules/estimates/components/snow/QuoteTotal';
import Invoices from '@/modules/estimates/components/snow/Invoices';
import estimatesAPI from '@/modules/estimates/api/estimates';

export default {
  name: 'snow-estimate-overview',
  props: {
    estimate: {
      required: true
    }
  },
  data: () => ({
    isLoading: true,
    snowEstimate: null
  }),
  computed: {
    subtitle () {
      if (this.estimate.site_address_is_owner_address) {
        return this.estimate.owner_obj.address
      } else {
        return this.estimate.site_address
      }
    }
  },
  created () {
    this.getEstimate()
  },
  methods: {
    async getEstimate () {
      this.isLoading = true
      this.snowEstimate = await estimatesAPI.getSnowEstimates(this.estimate.estimate_detail.id)
      this.isLoading = false
    },
    async updateEstimate (estimate) {
      this.$emit('update', estimate)
    },
    async updateSnowEstimate (estimateDetail) {
      this.snowEstimate = await estimatesAPI.updateSnowEstimate(estimateDetail)
      this.estimate.estimate_detail = this.snowEstimate
    }
  },
  components: {
    'basics': Basics,
    'site-address': SiteAddress,
    'snow-details': Details,
    'driveway-rating': DrivewayRating,
    'field-instructions': FieldInstructions,
    'customer-notes': CustomerNotes,
    'invoicing-notes': InvoicingNotes,
    'contacts': Contacts,
    'quote-total': QuoteTotal,
    'invoices': Invoices
  }
}
</script>
